
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M19.8329 19.5001H16.4996V17.8335H18.9996V6.16722H16.4996V4.50061H19.8329C20.0539 4.50061 20.2658 4.5884 20.4221 4.74468C20.5784 4.90096 20.6662 5.11291 20.6662 5.33392V18.6668C20.6662 18.8878 20.5784 19.0998 20.4221 19.256C20.2658 19.4123 20.0539 19.5001 19.8329 19.5001Z"></path><path d="M14.5338 2.19399C14.4406 2.11488 14.3308 2.05771 14.2125 2.0267C14.0943 1.99569 13.9706 1.99163 13.8505 2.01483L4.68414 3.68144C4.49228 3.71635 4.31874 3.81744 4.19373 3.96711C4.06872 4.11679 4.00017 4.30557 4 4.50058V18.6668C3.99996 18.8496 4.06007 19.0274 4.17105 19.1727C4.28203 19.318 4.43773 19.4228 4.61415 19.4709L13.7805 21.9708C13.852 21.99 13.9257 21.9998 13.9997 22C14.2207 22 14.4326 21.9122 14.5889 21.7559C14.7452 21.5997 14.833 21.3877 14.833 21.1667V2.83397C14.833 2.71189 14.8063 2.5913 14.7546 2.48071C14.7029 2.37012 14.6275 2.27224 14.5338 2.19399ZM12.3331 14.5002C12.3331 14.7213 12.2453 14.9332 12.089 15.0895C11.9327 15.2458 11.7208 15.3336 11.4998 15.3336C11.2787 15.3336 11.0668 15.2458 10.9105 15.0895C10.7542 14.9332 10.6664 14.7213 10.6664 14.5002V12.8336C10.6664 12.6126 10.7542 12.4007 10.9105 12.2444C11.0668 12.0881 11.2787 12.0003 11.4998 12.0003C11.7208 12.0003 11.9327 12.0881 12.089 12.2444C12.2453 12.4007 12.3331 12.6126 12.3331 12.8336V14.5002Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowLogoutFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
